module.exports = __webpack_public_path__ + "static/hackathon-10-bd444d58ab950b8465ab2705936c5717.jpg";